import type { ReactNode } from 'react';
import { IntegrationLogo } from '@/modules/integrations/components/integration-logo';
import { humanize } from '@/modules/simulator/ui/text';
import type { ToolDefinitionAction } from '@/services/toolDefinition.service';
import type { CustomToolStep } from '@/types/custom-tool.types';
import { useCustomToolBuilder } from '../builder/builder-context';

interface StepTitleProps {
	step: CustomToolStep;
	index: number;
	tool: ToolDefinitionAction | undefined;
	/** Shown after the integration's name. */
	detail?: ReactNode;
}

/** A step's number, integration and tool, or that the brand does not have the tool. */
export const StepTitle = ({ step, index, tool, detail }: StepTitleProps) => {
	const { stepTools } = useCustomToolBuilder();
	return (
		<>
			<span className='flex size-5 shrink-0 items-center justify-center rounded-full bg-gray-300 text-[11px] leading-none tabular-nums text-gray-900'>
				{index + 1}
			</span>
			<IntegrationLogo provider={step.provider} className='size-4' decorative />
			<div className='flex min-w-0 flex-1 flex-col'>
				<span className='truncate text-[13px] leading-4.5 font-medium text-ink'>{tool?.label ?? step.tool}</span>
				{tool || stepTools.isLoading ? (
					<span className='truncate text-[11px] leading-4 text-gray-800'>
						{humanize(step.provider)}
						{detail}
					</span>
				) : (
					<span className='truncate text-[11px] leading-4 text-red-600'>Not available for this brand</span>
				)}
			</div>
		</>
	);
};
